import React, { Component } from 'react'
import L from 'leaflet'
import 'leaflet-fullscreen'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet.markercluster'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet/dist/leaflet.css';
import './map.css'
import ReactDOMServer from 'react-dom/server';
import 'leaflet-polylinedecorator'
import Locked from '../../../Locked/Locked'
let map1,map2,map_data,mapped_locations_data=[],customDescription2,lane_data=[]
class Map extends Component {
    constructor(props){
        super(props);
        
    }
    componentDidMount(){
      customDescription2=undefined
        document.getElementById('map1').style.display='block';
        map1 = L.map('map1', {
            center: [20.5937, 78.9629],
            zoom: 4.5,
            maxZoom: 6,
            minZoom:4,
            zoomSnap:0.5,
            zoomControl:false,
            zoomDelta:0.5
          });
          L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
	attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
	subdomains: 'abcd',
	maxZoom: 19
}).addTo(map1);
L.control.fullscreen({
  position: 'topright', // change the position of the button can be topleft, topright, bottomright or bottomleft, defaut topleft
  forcePseudoFullscreen:true
  
}).addTo(map1);
map2 = L.map('map2', {
    center: [20.5937, 78.9629],
    zoom: 4.5,
    maxZoom: 6,
    zoomControl: false,
    minZoom:4,
    zoomSnap:0.5,
    zoomDelta:0.5
  });
  L.control.fullscreen({
    position: 'topright', // change the position of the button can be topleft, topright, bottomright or bottomleft, defaut topleft
    
  }).addTo(map2);
  L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
subdomains: 'abcd',
maxZoom: 19
}).addTo(map2);



    }
    componentWillReceiveProps(nextProps){
      map_data=nextProps.map_data.locations;
      lane_data=nextProps.map_data.network;
    
       mapped_locations_data=[];
       if(map_data==null || map_data==undefined)
       {
         map_data=[]
       }
       if(lane_data==null || lane_data==undefined)
       {
         lane_data=[]
       }
        map_data.forEach(item =>
        mapped_locations_data.push({
          locations: [item]
        })
      );
        this.updateMaps();
        this.plotNetwork();
    }
    plotNetwork=()=>{
      if(lane_data.length!=0){

        for(let i=0;i<lane_data.length;i++){
          let orginLatLng=new L.latLng([lane_data[i].origin.lat,lane_data[i].origin.lon])
          let destinationLatLng=new L.latLng([lane_data[i].destination.lat,lane_data[i].destination.lon])
          var line=new L.polyline([orginLatLng,destinationLatLng],{ color: '#007AFF', weight: 1,opacity:0.3 })
line.addTo(map2)

 L.polylineDecorator(line, {
  patterns: [
    {
      endOffset: '0%',
      offset: '53%',
      repeat: '0%',
      symbol: L.Symbol.arrowHead({
        pixelSize:6,
        polygon: false,
        pathOptions: { opacity:0.3,weight:2,stroke:true,color:'#007AFF' }
      })
    }
  ]
}).addTo(map2)

}
      }
    }
    updateMaps=()=>{
      var mcg = L.markerClusterGroup({
        iconCreateFunction:function (cluster) {
          var childCount = cluster.getChildCount();
          var c = ' marker-cluster1-';
          if (childCount <1) {
            c += 'small1';
          } else if (childCount < 100) {
            c += 'medium1';
          } else {
            c += 'large1';
          }
        
          return new L.DivIcon({ html: '<div><span>' + childCount + '</span></div>', className: 'marker-cluster1' + c, iconSize: new L.Point(20, 20) });
        
        },
        chunkedLoading: true,
        singleMarkerMode: true,
        spiderfyOnMaxZoom: true,
        maxClusterRadius:25,
        spiderLegPolylineOptions:{weight:3, color: 'red', opacity:0.75}
      });
  
      const features = this.createFeatureCollection(mapped_locations_data);
      for(let i=0;i<features.length;i++){
  
       var marker = L.marker(new L.LatLng(features[i].geometry.coordinates[1],features[i].geometry.coordinates[0]));
       marker.bindPopup(features[i].properties.description)
      let isclicked=false;
      marker.on('mouseover',function(ev){
      isclicked=false;
         ev.target.openPopup();
       })
       marker.on('mouseout',function(ev){
         if(!isclicked)
        ev.target.closePopup();
      })
      marker.on('click',function(ev){
        isclicked=true;
        ev.target.openPopup();
      })
        mcg.addLayer(marker);
      }
      map1.addLayer(mcg);
  
    }
  
  
  
     createFeatureCollection = locationsToDisplay => {
      let features = [];
  
      var uniqueLocations = locationsToDisplay; 
  
      for (var i = 0; i < uniqueLocations.length; i++) {
        let location = uniqueLocations[i];
  
        if (
          !location.locations ||
          !location.locations.length ||
          !location.locations[0].lon ||
          !location.locations[0].lat ||
          location.locations[0].lon === 'NA' ||
          location.locations[0].lat === 'NA'
        ) {
          continue;
        }
      
        var iconType= (i === 0) ? "marker" : "markerbranch";
  
        let feature = {
          type: 'Feature',
          properties: {
            description: customDescription2 || `<div>
            <h5>
              ${location.locations[0].location},${' '}
              ${location.locations[0].state}
            </h5>
            <h6 />
          </div>`,
            icon: iconType
          },
          geometry: {
            type: 'Point',
            coordinates: [location.locations[0].lon, location.locations[0].lat]
          }
          
        };
  
        features.push(feature);
      }
  
      return features;
    };
     customDescription = locationData => {
      return ReactDOMServer.renderToStaticMarkup(
        <div>
          <h5>
            {locationData.locations[0].location},{' '}
            {locationData.locations[0].state}
          </h5>
          <h6 />
        </div>
      );
    };
    
    
    openCity=(evt,cityName)=>{
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("tabcontent");
        window.dispatchEvent(new Event('resize'));
        map2.setView([20.5937, 78.9629],4.5)
/*         map1.setView([20.5937, 78.9629],4.5)
 */

        for (i = 0; i < tabcontent.length; i++) {
          tabcontent[i].style.display = "none";
        }
        tablinks = document.getElementsByClassName("tablinks");
        for (i = 0; i < tablinks.length; i++) {
          tablinks[i].className = tablinks[i].className.replace(" active", "");
        }
        document.getElementById(cityName).style.display = "block";
        evt.currentTarget.className += " active";
    }
    render() {
        return (
            <>
                <div class="tab">
  <button class="tablinks active" onClick={e=>this.openCity(e,'map1')}>Branch List{`(${map_data?.length})`}</button>
  <button class="tablinks" onClick={()=>document.getElementById('Login_to_view_button').click()}>Operating Lanes{`(${lane_data?.length})`}</button>
</div>
<div style={{height:'500px'}}>
<div id="map1"className="tabcontent"></div>
<div id="map2" className="tabcontent"></div>
</div>
            </>
        )
    }
}

export default Map
